import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

import ConductBanner from "../../Assets/principles-banner.jpg";

import commitmentImg from "../../Assets/professional-commitment.jpg";
import lawImg from "../../Assets/respect-law.jpg";
import employeeImg from "../../Assets/employee-rights.jpg";
import safetyImg from "../../Assets/worker-safety.jpg";

const PrinciplesOfConduct = () => {
  const principles = [
    {
      title: "Professional Commitment",
      image: commitmentImg,
      description:
        "At Khodiyar Industries, professionalism forms the foundation of our success. We encourage continuous learning, skill development, and knowledge enhancement to ensure that every employee performs with dedication, responsibility, and excellence. Our team is committed to delivering the highest standards of quality and service while embracing innovation and growth.",
    },
    {
      title: "Respect for the Law",
      image: lawImg,
      description:
        "We strictly comply with all applicable laws, regulations, and industry standards. Khodiyar Industries maintains the highest ethical standards in all business dealings and does not tolerate corruption, unfair practices, or any actions that compromise integrity and transparency.",
    },
    {
      title: "Employee Rights",
      image: employeeImg,
      description:
        "We believe that every employee deserves equal opportunities, dignity, and respect. Our workplace promotes fairness, diversity, and transparency while ensuring that all employees are treated equally and are protected by company policies and ethical standards.",
    },
    {
      title: "Worker Health & Safety",
      image: safetyImg,
      description:
        "The health and safety of our workforce are among our highest priorities. We provide a safe working environment, regular training programs, and appropriate safety measures to ensure the well-being of our employees. We are committed to creating a culture where safety is a shared responsibility.",
    },
  ];

  return (
    <div>
      <Header />

      {/* Banner */}
      <section
        className="container-fluid common_banner"
        style={{
          backgroundImage: `url(${ConductBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="common_title wow fadeInUp">
            <h2>
              <Link
                to="/AboutUs"
                className="text-decoration-none text-white"
              >
                ABOUT US
              </Link>{" "}
              <span className="text-white">/ Principles of Conduct</span>
            </h2>
          </div>
        </div>
      </section>/

      {/* Content */}
      <section className="container py-5">
        <div className="text-center mb-5">
          <h2
            style={{
              color: "#153fa4",
              fontWeight: "700",
              fontSize: "42px",
            }}
          >
            Principles of Conduct
          </h2>

          <p>
            Our principles guide every aspect of our business operations and
            reflect our commitment to quality, ethics, responsibility, and
            excellence.
          </p>
        </div>

        <div className="row">
          {principles.map((item, index) => (
            <div className="col-lg-6 mb-4" key={index}>
              <div
                className="card border-0 shadow h-100"
                style={{ borderRadius: "15px" }}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="card-img-top"
                  style={{
                    height: "250px",
                    objectFit: "cover",
                  }}
                />

                <div className="card-body">
                  <h4
                    style={{
                      color: "#153fa4",
                      fontWeight: "700",
                    }}
                  >
                    {item.title}
                  </h4>

                  <p>{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PrinciplesOfConduct;
